import React from 'react';

import { PhoneIcon } from './Icons';

export const PhoneNumberLink = ({ phoneNumber, className, iconClassName }) => (
  <a
    css={`
      display: flex;
      align-items: baseline;
      text-transform: uppercase;

      ${className};
    `}
    href={`tel:${phoneNumber.replace(/\s|\(0\)/g, '')}`}
  >
    <PhoneIcon className={iconClassName} />
    {phoneNumber}
  </a>
);



// WEBPACK FOOTER //
// ./app/components/PhoneNumberLink.js